export class PurchaseOrderDictionary{
    //类型
    static TYPE_SELF_PRODUCTION=1;
    static TYPE_OUTSOURCING_PRODUCTION=2;
    //状态
    static STATUS_NEW=1;
    static STATUS_IN_PRODUCTION=2;
    static STATUS_PRODUCTION_COMPLETE=3;
    static STATUS_SEND=4;
    static STATUS_ARRIVAL=5;
    static STATUS_SUCCESS=6;
    static STATUS_CLOSED=9;
}
export class PurchaseOrderSource{
    static TypeSource=[
        {value:PurchaseOrderDictionary.TYPE_OUTSOURCING_PRODUCTION,text:'外协'},
        {value:PurchaseOrderDictionary.TYPE_SELF_PRODUCTION,text:'本厂生产'}
    ];
    static StatusSource=[
        {value:PurchaseOrderDictionary.STATUS_NEW,text:'未开始'},
        {value:PurchaseOrderDictionary.STATUS_IN_PRODUCTION,text:'生产中'},
        {value:PurchaseOrderDictionary.STATUS_PRODUCTION_COMPLETE,text:'已完工'},
        {value:PurchaseOrderDictionary.STATUS_SEND,text:'已发货'},
        {value:PurchaseOrderDictionary.STATUS_ARRIVAL,text:'已到货'},
        {value:PurchaseOrderDictionary.STATUS_SUCCESS,text:'成功'},
        {value:PurchaseOrderDictionary.STATUS_CLOSED,text:'关闭'}
    ];
}